import Input from "../../design/Input"


export default ({text, language, textView, onChange, value, valueSelect, onChangeSelect, pattern}) => {

    return (
        <div className="containerSearch" style={{'direction': language == 'en' ? 'ltr' : 'rtl'}} >
            <p> {text} </p>

            <div className="searchSelectInput">
                <select value={valueSelect} onChange={onChangeSelect}>
                    <option value={1} >שווה בדיוק</option>
                    <option value={2} >מתחיל ב</option>
                    <option value={3} >מסתיים ב</option>
                    <option value={4} >מכיל</option>
                </select>

                <Input 
                value = {value}
                myStyle="inputborderNone" 
                textView={textView}  
                language={language}
                onChange={onChange} 
                pattern={pattern}
                />
            </div>
        </div>
    )
}